export default class GetFailedReportItemsRequest {
    public deviceExternalId: string = "";

    public count: number = 0;
}